import { Box } from "@mui/material";

import type { IHeaderParams } from "ag-grid-community";
import type { FC } from "react";

const HEADER_BORDER = "1px solid var(--ag-border-color, #babfc7)";

export type RenewalPremiumHeaderParams = IHeaderParams & {
  /** "Renewal" or "Rev. Ren.", matching the rates table's own column label. */
  renewalLabel: string;
};

const labelSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  px: 1,
  height: "100%",
  whiteSpace: "nowrap",
} as const;

/**
 * Header for a Current plan's premium column when it has renewal rates: "Current" and the
 * renewal label split the column evenly like the premium cells below, replacing the plan name.
 */
export const RenewalPremiumHeader: FC<RenewalPremiumHeaderParams> = ({
  renewalLabel,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      width: "100%",
      height: "100%",
    }}
  >
    <Box sx={labelSx}>Current</Box>
    <Box sx={{ ...labelSx, borderLeft: HEADER_BORDER }}>{renewalLabel}</Box>
  </Box>
);
